import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class AttestatiService {

  static generaAttestato = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/attestati/genera`;
      ApiService.postRequest(resolve, reject, url, data)
  });
  };

  static verifyAttestato = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/attestati/verifica`;
      ApiService.postRequest(resolve, reject, url, data)
    });
  }

  static downloadAttestato = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/attestati/download`;
      ApiService.postRequestWithDownload(resolve, reject, url, {
        ...data,
        filename: `attestato_${data.id_classe_utente}.pdf`
      });
    });
  };

}